// 首頁、話題、搜尋頁 - 瀑布流內容

'use client';
import { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import MasonryPostComponent from './MasonryPostComponent';
import MasonrySkelton from './MasonrySkelton';

const MasonryWrapper = ({ posts = [], type, handleClick = () => {}, onToggleLike = () => {} }) => {
    const [mounted, setMounted] = useState(false);

    // 首頁、搜尋、話題
    const breakpointsMap = {
        index: {
            default: 5,
            1511: 4,
            1379: 3,
            767: 2,
        },
        acg: {
            default: 2,
        },
    };

    const styleMap = {
        index: 'px-[107px] uxxl:px-[30px] ulg:!px-0',
    };

    useEffect(() => {
        setTimeout(
            () => {
                setMounted(true);
            },
            type === 'topic' ? 800 : 0,
        );
    }, []);

    const breakpoints = { ...breakpointsMap?.[type] };

    // 載入畫面
    if (!mounted) return <MasonrySkelton type={type} />;

    return (
        <section id="support" className={`w-full mx-auto scroll-mt-[80px] ${styleMap?.[type]}`}>
            <Masonry
                breakpointCols={breakpoints}
                className="my-masonry-grid flex gap-x-[4px] [&>*]:space-y-[8px]"
                columnClassName="my-masonry-grid_column"
            >
                {posts?.map((post, index) => (
                    <MasonryPostComponent
                        key={'masonry' + index}
                        post={post}
                        handleClick={handleClick}
                        onToggleLike={onToggleLike}
                        type={type}
                    />
                ))}
            </Masonry>
        </section>
    );
};

export default MasonryWrapper;
